import type { IconName } from "@similarweb/icons";

export enum HomeContextMenuOptions {
    Subscribe = "Subscribe",
    ConnectGa = "ConnectGa",
    Settings = "Settings",
}

export const CONTEXT_MENU_ITEMS = [
    {
        id: HomeContextMenuOptions.Subscribe,
        title: "activation.home.list.context.menu.subscribe.text",
        icon: "email" as IconName,
    },
    {
        id: HomeContextMenuOptions.ConnectGa,
        title: "activation.home.list.context.menu.connectGa.text",
        icon: "ga-icon-disabled" as IconName,
    },
    {
        id: HomeContextMenuOptions.Settings,
        title: "activation.home.list.context.menu.settings.text",
        icon: "settings" as IconName,
    },
];

export const MENU_WIDTH = 260;
export const WRAPPER_ID = "HomeContextMenu";
